/**
 * Collections section sub-navigation: Plans (membership/charge plans) and
 * Enrolments (the per-player subscriptions billed to a payer). Mirrors
 * TeamNav — reuses its tab styling so Collections reads as one module.
 */
import { NavLink, useLocation } from 'react-router-dom';
import './TeamNav.css';

const TABS = [
  { to: '/collections', label: 'Plans' },
  { to: '/collections/subscriptions', label: 'Enrolments' },
  { to: '/collections/payers', label: 'Payers' },
];

export default function CollectionsNav() {
  const location = useLocation();
  return (
    <nav className="tm-nav" aria-label="Collections sections">
      <div className="tm-nav-tabs">
        {TABS.map(tab => (
          <NavLink key={tab.to} to={tab.to} className={`tm-nav-tab ${location.pathname === tab.to ? 'active' : ''}`}>
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
